/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/no-null */
import dayjs from 'dayjs';
import _ from 'lodash';

import { DATE_FORMAT } from '@/constants/datetime.constants';

const isNilOrEmpty = (value: any) =>
  [undefined, null].includes(value) || value?.length === 0;

const customizer = (value1: any, value2: any) => {
  if (isNilOrEmpty(value1) && isNilOrEmpty(value2)) {
    return true;
  }

  if (dayjs.isDayjs(value1) || dayjs.isDayjs(value2)) {
    return dayjs(value1?.format(DATE_FORMAT)).isSame(
      dayjs(value2?.format(DATE_FORMAT)),
    );
  }

  if (typeof value1 === 'number' && typeof value2 === 'number') {
    return value1.toFixed(5) === value2.toFixed(5);
  }
};

const compareObjects = (object1: unknown, object2: unknown) =>
  _.isEqualWith(object1, object2, customizer);

export { compareObjects };
